import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/styles';
import Helpers from '../global/helpers';
import { FixedSizeList } from 'react-window';
import { useStyles } from './styles';

import { 
    List,
    ListItem,
    ListItemText,
    TextField,
    Popover,
    Typography
} from '@material-ui/core';


var timeout = null;


const TicketSelectSite = props => {

    const theme = useTheme();
    const styles = useStyles(theme);

    const [filter, setFilter] = useState('');
    const [openPopover, setOpenPopover] = useState(false);
    const [filteredData, setFilteredData] = useState([]);

    const searchSites = useRef(null);

    const handleFilterChange = e => {
        const filterStr = e.target.value;
        setFilter(filterStr);

        if(timeout != null)
            clearTimeout(timeout);

        timeout = setTimeout(() => {
            filterData(filterStr);
        }, 750)
    }

    const handleAdd = s => {
        props.handleAdd({
            id_ticket: props.ticket.id_ticket,
            id_site: s.ChargeSiteID
        })
    }

    const filterData = (filterStr) => {

        setOpenPopover(true);

        let result = [];

        if(filterStr.length !== 0 && filterStr != ''){
            props.sites.map(d => {
                const concatStr = `${d.SiteName.toUpperCase()}${d.GroupSchemeName.toUpperCase()}`;
                const idx = concatStr.indexOf(filterStr.toUpperCase());
                if(idx > -1)
                    result.push({...d, idx: idx});
            })            
        } else {
            setOpenPopover(false);
        }

        setFilteredData(Helpers.multiSort(result, [{orderBy: 'idx', order: 'asc'}, {orderBy: 'SiteName', order: 'asc'}]));
            
    }

    

    const DataRow = props => {
        const { index, style, data } = props;
        const s = data[index];

        return (
            <ListItem key={index} button onClick={() => handleAdd(s)} style={style}>
                <ListItemText primary={s.SiteName} secondary={s.GroupSchemeName} />
            </ListItem>
        );
    }
    

    return (
        <div>

            <TextField 
                className={styles.inputField} 
                ref={searchSites} 
                variant="outlined" 
                fullWidth 
                name="filter" 
                label="Search Sites" 
                value={filter} 
                onChange={handleFilterChange} 
                autoComplete="off"
                size="small" />

            <Popover
                id='sites_results_popover'
                open={openPopover}
                anchorEl={searchSites.current}
                onClose={() => setOpenPopover(false)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                disableAutoFocus
                disableEnforceFocus
            >
                
                {filteredData.length == 0 && <div style={{padding: 20}}><Typography>No site found</Typography></div>}
                <FixedSizeList height={180} width={400} itemSize={60} itemCount={filteredData.length} itemData={filteredData}>
                    {DataRow}
                </FixedSizeList>
            </Popover>

        </div>
    )

}

export default TicketSelectSite